import { useState, useCallback } from 'react';

export const useFactorGame = () => {
  const [currentNumber, setCurrentNumber] = useState(12);
  const [discoveredFactors, setDiscoveredFactors] = useState<Set<number>>(new Set());
  const [discoveredLetters, setDiscoveredLetters] = useState<Set<string>>(new Set());
  const [score, setScore] = useState(0);
  const [gameOver, setGameOver] = useState(false);

  const secretWord = "FACTORS";
  const clues = [
    "Find factors to reveal letters",
    "Each correct factor adds points",
    "Complete the word to win!"
  ];

  const getFactors = (num: number): number[] => {
    const factors: number[] = [];
    for (let i = 1; i <= num; i++) {
      if (num % i === 0) {
        factors.push(i);
      }
    }
    return factors;
  };

  const checkFactor = useCallback((factor: number): boolean => {
    if (currentNumber % factor === 0 && !discoveredFactors.has(factor)) {
      const newDiscoveredFactors = new Set(discoveredFactors);
      newDiscoveredFactors.add(factor);
      setDiscoveredFactors(newDiscoveredFactors);

      // Reveal a new letter
      const letterIndex = newDiscoveredFactors.size - 1;
      if (letterIndex < secretWord.length) {
        const newDiscoveredLetters = new Set(discoveredLetters);
        newDiscoveredLetters.add(secretWord[letterIndex]);
        setDiscoveredLetters(newDiscoveredLetters);
      }

      setScore(score + 10);

      // Check if all factors are found
      if (newDiscoveredFactors.size === getFactors(currentNumber).length) {
        setGameOver(true);
      }

      return true;
    }
    return false;
  }, [currentNumber, discoveredFactors, discoveredLetters, score, secretWord]);

  const resetGame = useCallback(() => {
    setCurrentNumber(12);
    setDiscoveredFactors(new Set());
    setDiscoveredLetters(new Set());
    setScore(0);
    setGameOver(false);
  }, []);

  return {
    currentNumber,
    clues,
    secretWord,
    discoveredLetters,
    score,
    gameOver,
    checkFactor,
    resetGame
  };
};